import Rest from '../Rest'

/**
 * Cartões de usuários (gestão): API sob /subscriptions/users/{userId}/credit_cards
 *
 * Sem cadastro: o cartão é criptografado no navegador do titular pelo SDK do
 * PagBank, então quem cadastra é o marketplace.
 */
export default class UserCreditCardService extends Rest {
  static resource = '/api/v1/subscriptions/users'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  list(userId: number) {
    return this.get(`/${userId}/credit_cards`)
  }

  setDefault(userId: number, cardId: number) {
    return this.post(`/${userId}/credit_cards/${cardId}/set_default`, {})
  }

  deleteCard(userId: number, cardId: number) {
    return this.delete(`/${userId}/credit_cards/${cardId}`)
  }
}
